import { hooks, mui, React } from '_core';

import { DraftParams } from './types';
import BenchmarkTargetSelector from '../../common/forms/benchmark-target-selector';

type FormProps = {
  params: DraftParams;
  setParams: (_p: DraftParams) => void;
};

const Form = ({ params, setParams }: FormProps) => {
  const [benchmark, setBenchmark] = React.useState(params.benchmark || null);
  const [withBenchmark, setWithBenchmark] = React.useState(params.with_benchmark || false);
  const uiStyles = hooks.useUiStyles();

  React.useEffect(() => {
    const data = {
      ...params,
      with_benchmark: withBenchmark,
    } as DraftParams;

    if (withBenchmark) data.benchmark = benchmark ?? undefined;
    else delete data.benchmark;

    setParams(data);
  }, [withBenchmark, benchmark]);

  return (
    <mui.core.Box sx={uiStyles.widgetEditMode}>
      <BenchmarkTargetSelector
        withBenchmark={withBenchmark}
        benchmark={benchmark}
        setBenchmark={setBenchmark}
        setWithBenchmark={setWithBenchmark}
      />
    </mui.core.Box>
  );
};

export default Form;
